import { Alert, Box, Button, InputLabel, OutlinedInput, Snackbar, Typography, useTheme } from '@mui/material';
import { AuthContainer } from './style';
import LoadingButton from '@mui/lab/LoadingButton';
import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import logo from '../../assets/logo/Logo.svg';
import logo360 from '../../assets/logo/PRIME36oBlueLogo.svg';

const getAllUrlParams = (url) => {
    let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    let obj = {};

    if (queryString) {
        queryString = queryString.split('#')[0];

        let arr = queryString.split('&');

        for (let i = 0; i < arr.length; i++) {
            let a = arr[i].split('=');

            let paramName = a[0];
            let paramValue = typeof a[1] === 'undefined' ? true : a[1];

            if (paramName.match(/\[(\d+)?\]$/)) {
                let key = paramName.replace(/\[(\d+)?\]/, '');
                if (!obj[key]) obj[key] = [];

                if (paramName.match(/\[\d+\]$/)) {
                    let index = /\[(\d+)\]/.exec(paramName)[1];
                    obj[key][index] = paramValue;
                } else {
                    obj[key].push(paramValue);
                }
            } else {
                if (!obj[paramName]) {
                    obj[paramName] = paramValue;
                } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                    obj[paramName] = [obj[paramName]];
                    obj[paramName].push(paramValue);
                } else {
                    obj[paramName].push(paramValue);
                }
            }
        }
    }

    return obj;
};

function Login() {
    const theme = useTheme();
    const [openToster, setOpenToster] = useState(false);
    const [tosterVariant, setTosterVariant] = useState('error');
    const [tosterMessage, setTosterMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const query = getAllUrlParams(window.location.search);
    const defaultEmail = query?.email;

    const { user, passwordLessLogin, getUserDetailsNotAsync, login, isAuthenticated } = useAuth();
    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        const formData = new FormData(event.currentTarget);
        let record = {};
        record.email = formData.get('email')?.trim();

        passwordLessLogin({
            email: formData.get('email')?.trim(),
            callback: (failed) => {
                if (failed) {
                    setTosterVariant('error');
                    setTosterMessage(failed ? failed : `Sorry, we don't recognize this email address`);
                    setOpenToster(true);
                }
                setLoading(false);
            },
        });
    };

    const handleTosterClose = () => {
        setOpenToster(false);
    };

    return (
        <AuthContainer>
            <Box
                display={'flex'}
                flexDirection={'column'}
                sx={{
                    wordBreak: 'break-word',
                }}
            >
                <Box display="flex" justifyContent="center">
                    {window.location.hostname?.startsWith('tax.') ? <img src={logo} height={40} width={120} alt="Logo" /> : <img src={logo360} height={40} width={120} alt="Logo" />}
                </Box>

                <Typography
                    component={'h1'}
                    variant="heading1"
                    color={'text.primary'}
                    // color={theme.palette.text.primary}
                    fontSize={{
                        xs: theme.typography.customFontSize.xxxLarge,
                        sm: theme.typography.customFontSize.verylarge,
                    }}
                    // fontWeight={theme.typography.fontWeightBold}
                    textAlign={{
                        xs: 'center',
                    }}
                    fontFamily='"Barlow Condensed", sans-serif'
                    marginTop={{
                        xs: theme.typography.generic.large,
                    }}
                >
                    {window.location.hostname?.startsWith('tax.') ? 'Tax Assessment' : 'Log in to your account'}
                </Typography>
                <Typography
                    component={'p'}
                    color={'text.secondary'}
                    variant="subHeading"
                    // color={theme.palette.text.secondary}
                    fontSize={{
                        xs: theme.typography.customFontSize.medium,
                        sm: theme.typography.customFontSize.large,
                    }}
                    // fontWeight={theme.typography.fontWeightSemiBold}
                    textAlign={{
                        xs: 'center',
                    }}
                    marginTop={{
                        xs: theme.typography.generic.medium,
                    }}
                    // lineHeight='140%'
                >
                    Enter your email to get a login code.
                    <br />
                    No password necessary.
                </Typography>
            </Box>
            <Box component="form" onSubmit={handleSubmit} width={'100%'}>
                <Box display={'flex'} flexDirection={'column'} gap={theme.typography.generic.xxSmall} width={'100%'}>
                    {/* <InputLabel htmlFor="email">Email Address</InputLabel> */}
                    <OutlinedInput id="email" type="email" name="email" placeholder="Enter email address" defaultValue={defaultEmail} />
                </Box>

                <LoadingButton loading={loading} type="submit" fullWidth variant="contained" size="large" sx={{ mt: '1rem', textTransform: 'inherit' }}>
                    Send my login code
                </LoadingButton>

                {window.location.hostname?.startsWith('tax.') && (
                    <Typography
                        component={'p'}
                        color={'text.secondary'}
                        fontSize={'13px'}
                        textAlign={{
                            xs: 'center',
                        }}
                        marginTop={{
                            xs: theme.typography.generic.medium,
                        }}
                        // lineHeight='140%'
                    >
                        For questions or support related to this assessment or your tax plan, please contact us at <br></br>
                        <a style={{ color: '#00297A' }} href="mailto:decoder@primecorporateservices.com">
                            decoder@primecorporateservices.com
                        </a>
                    </Typography>
                )}
            </Box>
            <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openToster} autoHideDuration={6000} onClose={handleTosterClose}>
                <Alert onClose={handleTosterClose} severity={tosterVariant} variant="filled">
                    {tosterMessage}
                </Alert>
            </Snackbar>
        </AuthContainer>
    );
}

export default Login;
